import { render, staticRenderFns } from "./CalendarioServicio.vue?vue&type=template&id=e5497bd6"
import script from "./CalendarioServicio.vue?vue&type=script&lang=js"
export * from "./CalendarioServicio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports